import { useState, useEffect, useContext } from 'react';
import "../css/Modal.css"
import Select from 'react-select';
import { scrollToTop } from "../utils/helper.js";
import { ddStyles } from "../utils/CommonStyles.js";
import SupplierAppSurveyTable from "./SupplierAppSurveyTable";
import SupplierProductTable from "./SupplierProductTable";
import SupplierLocationTable from "./SupplierLocationTable";
import SupplierDateTable from "./SupplierDateTable";

import UserContext from "../contexts/UserContext";

function PartnerDetailsModal({ key, t, partner, supplierCompanyId, supplierCompanyName, setDetails, detailComplete }) {
	let menuOptions = [
		{ label: t("page.setDates"), value: "Set Dates" },
		{ label: t("page.appSurvey"), value: "App Survey" },
		{ label: t("page.loc"), value: "Location" },
		{ label: t("page.prod"), value: "Product" }
	];

	const [isSubmit, setIsSubmit] = useState(false);
	const [menuSelected, setMenuSelected] = useState({ name: "menuOption", label: "", value: "" });
	const [appSurvey, setAppSurvey] = useState(false);
	const [location, setLocation] = useState(false);
	const [product, setProduct] = useState(false);
	const [date, setDate] = useState(false);
	const [error, setError] = useState("");
	const userCtx = useContext(UserContext);

	useEffect(() => {
		scrollToTop();
	}, []);

	const closeText = t("page.close");

	const menuOptionHandler = (selectedOption, action) => {
		let menuOption = selectedOption ? selectedOption.value : "";
		if (selectedOption) {
			setMenuSelected(selectedOption);
		} else {
			setMenuSelected({ name: "menuOption", label: "", value: "" });
		}

		switch (menuOption) {
			case "App Survey": handleAppSurveyClick();
				break;
			case "Location": handleLocationClick();
				break;
			case "Product": handleProductClick();
				break;
			case "Set Dates": handleDateClick();
				break;
			default: break;
		}
	}

	const resetMenu = () => {
		setMenuSelected({ name: "menuOption", label: "", value: "" });
	}

	const resetAllSelections = () => {
		setLocation(false);
		setProduct(false);
		setAppSurvey(false);
		setDate(false);
	}

	const handleAppSurveyClick = () => {
		setError("");
		resetAllSelections();
		setAppSurvey(true);
	};

	const handleLocationClick = () => {
		setError("");
		resetAllSelections();
		setLocation(true);
	};

	const handleProductClick = () => {
		setError("");
		resetAllSelections();
		setProduct(true);
	};
	const handleDateClick = () => {
		setError("");
		resetAllSelections();
		setDate(true);
	};

	const handleClose = () => {
		setError("");
		setDetails(false);
		detailComplete();
	};

	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="modalContainer">
					<div className="row">
						<div className="col mt-3">
							<div id="compInfo" className="header-label">
								{t("page.supplier") + ": " + supplierCompanyName}
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col mt-3">
							<div id="compInfo" className="header-label">
								{t("page.buyer") + ": " + partner.clientCompanyName}
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div className="form-group">
								<label className="form-label">
									{t("page.option")}
								</label>
								<Select
									name="menuOption"
									options={menuOptions}
									onChange={menuOptionHandler}
									value={menuSelected}
									isSearchable={true}
									isClearable={true}
									className="myselect"
									inputId="menu-input"
									styles={ddStyles}
								/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>

					{appSurvey &&
						<SupplierAppSurveyTable key={key} setAppSurvey={setAppSurvey} partner={partner} supplierCompanyId={supplierCompanyId} resetMenu={resetMenu} />
					}
					{location &&
						<SupplierLocationTable key={key} setLocation={setLocation} partner={partner} supplierCompanyId={supplierCompanyId} resetMenu={resetMenu} />
					}

					{product &&
						<SupplierProductTable key={key} setProduct={setProduct} partner={partner} supplierCompanyId={supplierCompanyId} resetMenu={resetMenu} />
					}
					
					{date &&
						<SupplierDateTable key={key} setDate={setDate} partner={partner} supplierCompanyId={supplierCompanyId} resetMenu={resetMenu} />
					}

					{!(appSurvey || product || location || date) &&
						<div className="footer">
							<input
								type="button"
								name="edit-part-detail-close"
								id="edit-part-detail-close"
								className="btn btn-secondary btn-block" data-dismiss="modal"
								disabled={isSubmit}
								onClick={(e) => handleClose()}
								 style={{ marginTop: "10px", marginBottom: "10px" }}
								value={closeText}
							></input>
						</div>
					}
				</div>
				: null}
		</>
	);
}

export default PartnerDetailsModal;